import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Courses from './components/Courses';
import Features from './components/Features';
import About from './components/About';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import CourseDetail from './components/CourseDetail';
import NotFound from './components/NotFound';
import BuyMonecle from './components/BuyMonecle';
import ContactFormModal from './components/ContactFormModal';
import BuyCourseModal from './components/BuyCourseModal';
import PromoOffer from './components/PromoOffer';
import { ContactFormProvider } from './context/ContactFormContext';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Home page component
const Home = () => {
  useEffect(() => {
    // Smooth scroll for anchor links
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (anchor) {
        e.preventDefault();
        const id = anchor.getAttribute('href')?.slice(1);
        if (id) {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Courses />
        <Features />
        <About />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="min-h-screen bg-crypto-black overflow-x-hidden">
      <ContactFormProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/course/:id" element={<CourseDetail />} />
            <Route path="/BuyMonecle" element={<BuyMonecle />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <BuyCourseModal />
          <ContactFormModal />
          <PromoOffer />
        </BrowserRouter>
      </ContactFormProvider>
    </div>
  );
}

export default App;
